import React, {memo} from 'react';
import {Box} from '@mui/material';
import {ChartsXAxis} from '@mui/x-charts';
import {BarChart} from '@mui/x-charts/BarChart';
import {numberInUSFormat} from 'mui-core/utils';

const HorizontalBar = ({
  data = [],
  xAxisLeft = 55,
  width = '80vw',
  height = '500px',
  xAxisBottom = '0px',
  yAxisLabelWidth = 80,
  yAxisBarHieght = 100,
  categoryGapRatio = 0.5,
  yAxisOverflow = 'hidden',
}) => {
  return (
    <Box
      sx={{
        width: width,
        height: height,
        overflowY: 'hidden',
        position: 'relative',
        backgroundColor: 'inherit',
      }}>
      <Box
        sx={{
          zIndex: 3,
          left: '0px',
          width: '100%',
          height: '45px',
          overflow: 'hidden',
          bottom: xAxisBottom,
          position: 'absolute',
          pointerEvents: 'none',
          backgroundColor: 'inherit',
        }}>
        <BarChart
          layout="horizontal"
          height={45}
          xAxis={[
            {
              position: 'bottom',
              scaleType: 'linear',
            },
          ]}
          margin={{left: xAxisLeft}}
          series={[
            {
              data: data.map(item => item.value),
              barLabel: true,
              barLabelPosition: 'end',
            },
          ]}
          sx={{
            '& .MuiChartsAxis-root.MuiChartsAxis-directionY.MuiChartsAxis-left': {
              display: 'none',
            },
            '& .MuiChartsAxis-root.MuiChartsAxis-directionX.MuiChartsAxis-bottom': {
              display: 'block',
            },
            '& .MuiChartsGrid-root': {
              display: 'none',
            },
          }}>
          <ChartsXAxis />
        </BarChart>
      </Box>
      <Box
        sx={{
          zIndex: 1,
          flexGrow: 1,
          height: '100%',
          overflowX: 'hidden',
          position: 'relative',
          overflowY: yAxisOverflow,
          '& .MuiBarLabel-root': {
            fill: '#fff',
          },
        }}>
        <Box
          sx={{
            height: '100%',
            minHeight: `${data.length * yAxisBarHieght}px`,
            '& #barChartYaxis .MuiChartsAxis-root.MuiChartsAxis-directionX.MuiChartsAxis-bottom': {
              display: 'none',
            },
          }}>
          <BarChart
            dataset={data}
            borderRadius={10}
            id="barChartYaxis"
            layout="horizontal"
            slotProps={{
              bar: {height: 100},
            }}
            barLabel="value"
            yAxis={[
              {
                colorMap: {
                  type: 'ordinal',
                  colors: ['#635BFF'],
                },
                dataKey: 'label',
                scaleType: 'band',
                width: yAxisLabelWidth,
                categoryGapRatio: categoryGapRatio,
                tickLabelStyle: {
                  fontSize: 12,
                  textWrap: 'wrap',
                  fontFamily: 'Inter',
                },
              },
            ]}
            grid={{vertical: true}}
            series={[
              {
                showLabel: true,
                barLabelPosition: 'end',
                data: data.map(item => numberInUSFormat(item.value)),
              },
            ]}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default memo(HorizontalBar);
